import React from 'react'
import { Box, Tooltip, Typography } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"


export default function priceComparisonColumn() {

	const iconMap = {
		"More expensive": "chart-line-up",
		"Cheaper": "chart-line-down",
		"Cheaper/More expensive": "chart-line-up-down",
		"$": "money-bills",
		"%": "percent"
	}
	const colorMap = {
		"More expensive": "success.main",
		"Cheaper": "error.main",
		"Cheaper/More expensive": "warning.main",
		"$": "success.dark",
		"%": "black"
	}

	return {
		name: 'comparatorValue',
		label: "Condition",
		options: {
			customBodyRowRenderLite: (value, { comparatorName, comparatorUnitName }) => <Box
				sx={{ display: "flex", alignItems: 'center', justifyContent: "center" }}>
				<Tooltip title="Amount" placement="top" arrow>
					<Typography sx={{ fontWeight: "bold" }}>{value}</Typography>
				</Tooltip>
				<IconSeeker
					tooltip={comparatorUnitName === "$" ? "Currency" : "Percentage"}
					icon={iconMap[comparatorUnitName]}
					sx={{
						mx: .7,
						fontSize: 14,
						color: colorMap[comparatorUnitName]
					}}
				/>
				<IconSeeker
					tooltip={comparatorName}
					icon={iconMap[comparatorName]}
					sx={{ fontSize: 14, color: colorMap[comparatorName] }}
				/>
			</Box>
		}
	}
}